import { render, staticRenderFns } from "./verFatura.vue?vue&type=template&id=3cb1bba8"
import script from "./verFatura.vue?vue&type=script&lang=js"
export * from "./verFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports